<template>
  <div class="month-and-staff big">
    <div class="month-and-staff-header">
      <el-form :inline="true"
               :model="monthAndStaffForm"
               ref="monthAndStaffFormRef">

        <el-form-item label="员工账号："
                      :label-width="labelWidth">
          <el-input v-model="monthAndStaffForm.phone"
                    clearable
                    @input="searchList"
                    placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="员工姓名："
                      :label-width="labelWidth">
          <el-input v-model="monthAndStaffForm.recommender_name"
                    clearable
                    @input="searchList"
                    placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="工号："
                      :label-width="labelWidth">
          <el-input v-model="monthAndStaffForm.recommender_code"
                    clearable
                    @input="searchList"
                    placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="状态："
                      :label-width="labelWidth">
          <el-select v-model="monthAndStaffForm.status"
                     @change="searchList"
                     placeholder="全部">
            <el-option v-for="item in options"
                       :key="item.value"
                       v-show="!item.isShow"
                       :label="item.label"
                       :value="item.value"></el-option>

          </el-select>
          <el-checkbox v-model="options[1].isShow"
                       @change="transactionClick"
                       style="margin-left:20px">不含未扎帐</el-checkbox>
        </el-form-item>

        <el-form-item label="相关订单号："
                      :label-width="labelWidth">
          <el-input v-model="monthAndStaffForm.order_sn"
                    clearable
                    @input="searchList"
                    placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="时间："
                      :label-width="labelWidth">
          <el-date-picker v-model="monthAndStaffForm.time_date"
                          type="monthrange"
                          align="right"
                          unlink-panels
                          format="yyyy-MM"
                          value-format="yyyy-MM"
                          range-separator="至"
                          start-placeholder="开始月份"
                          end-placeholder="结束月份"
                          @change="searchList"
                          :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="筛选："
                      :label-width="labelWidth">
          <el-radio-group v-model="monthAndStaffForm.is_abnormal"
                          @change="searchList">
            <el-radio :label="0">全部</el-radio>
            <el-radio :label="1">不含异常</el-radio>
            <el-radio :label="2">仅含异常</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item>
          <el-button type="primary"
                     size="small"
                     @click="searchList">查询
          </el-button>
          <el-button size="small"
                     @click="resetBtn">重置</el-button>
        </el-form-item>

      </el-form>

      <div class="fun-point">
        <el-button type="primary"
                   :disabled="module_id_array[0]? !module_id_array.includes('648'): false"
                   @click="outData">导出Excel</el-button>
        <div class="batch">
          <el-button type="primary"
                     size="small"
                     :disabled="isSetMention && !module_id_array[0]? !module_id_array.includes('643'): false"
                     @click="batchSetMention">批量设为可提</el-button>
          <el-button type="primary"
                     size="small"
                     :disabled="isSetNotMention && !module_id_array[0]? !module_id_array.includes('643'): false"
                     @click="batchSetNotMention">批量设为不可提</el-button>
          <el-button type="primary"
                     size="small"
                     :disabled="isPass && !module_id_array[0]? !module_id_array.includes('644'): false"
                     @click="batchPass">批量通过</el-button>
        </div>
        <div class="abnormal">
          <el-button type="danger"
                     size="small"
                     :disabled="isSetAbnormal && !module_id_array[0]? !module_id_array.includes('645'): false"
                     @click="setAbnormal">设为异常</el-button>
          <el-button type="danger"
                     size="small"
                     :disabled="isSetAbnormal && !module_id_array[0]? !module_id_array.includes('645'): false"
                     @click="cancelAbnormal">取消异常</el-button>
        </div>
      </div>
    </div>

    <div class="month-and-staff-body">
      <el-table v-loading="tableLoading"
                ref="monthAndStaffTableRef"
                :data="monthAndStaffTable"
                tooltip-effect="dark"
                style="width: 100%; min-width: 1000px"
                :header-cell-style="{ background: '#F5F5F5' }"
                @selection-change="handleSelectionChange"
                @cell-dblclick="editorMoney"
                :key="refreshKey">
        <el-table-column type="selection"
                         width="55">
        </el-table-column>

        <el-table-column v-for="(item,index) in tableHeader"
                         :key="item.prop"
                         :prop="item.prop"
                         :label="item.label"
                         :width="item.width">
          <template slot-scope="scope">
            <div v-if="item.prop == 'date'">
              {{ scope.row[item.prop] | dateFormat  }}
            </div>
            <div v-else-if="item.prop == 'recommender_name'">
              {{ scope.row[item.prop] }}({{ scope.row.phone}})
            </div>
            <div v-else-if="item.prop == 'money'">
              <div v-if="scope.row.isMoneyShow"
                   class="editor-money-box">
                <el-input-number v-model="scope.row.money"
                                 v-focus
                                 :precision="2"
                                 :controls='false'
                                 :min="0"></el-input-number>
                <el-button type="primary"
                           size="mini"
                           @click="confirmMoney(scope.row,index)">确认</el-button>
                <el-button size="mini"
                           @click="scope.row.isMoneyShow = false">取消</el-button>
              </div>

              <span v-else>{{scope.row.money}}</span>
            </div>
            <div v-else-if="item.prop == 'status'">
              <span v-if="!scope.row.is_abnormal"> {{ scope.row[item.prop] | filterStatus }}</span>

              <el-badge v-else
                        value="异常">
                <span> {{ scope.row[item.prop] | filterStatus }}</span>
              </el-badge>
            </div>
            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>

        </el-table-column>

        <el-table-column label="操作"
                         width="360">
          <template slot-scope="scope">
            <el-button type="text"
                       @click="relevantOrdersBtn(scope.row)"
                       :disabled="module_id_array[0]?!module_id_array.includes('641'):false">相关订单</el-button>

            <el-button v-if="scope.row.status && scope.row.status == 1"
                       type="text"
                       @click="setMention(scope.row)"
                       :disabled="module_id_array[0]? !module_id_array.includes('643'): false">设为可提</el-button>

            <el-button v-if="scope.row.status && scope.row.status == 2"
                       type="text"
                       @click="setNotMention(scope.row)"
                       :disabled="module_id_array[0]? !module_id_array.includes('643'): false">设为不可提</el-button>

            <el-button v-if="scope.row.status && scope.row.status == 3"
                       type="text"
                       @click="passBtn(scope.row)"
                       :disabled="module_id_array[0]? !module_id_array.includes('644'): false">通过</el-button>
          </template>
        </el-table-column>

      </el-table>
      <!-- 分页 -->
      <pagination v-show="totalNum>0"
                  :total="totalNum"
                  :page.sync="pagination.page"
                  :limit.sync="pagination.pageNumber"
                  @pagination="getList" />
    </div>

    <el-dialog title="相关已支付订单"
               :visible.sync="dialogOrder"
               width="900px"
               style="text-align: left"
               :close-on-click-modal="false">
      <div class="relevant-orders">
        <div class="relevant-orders-header">
          <dl>
            <dt>订单数</dt>
            <dd>{{ relevantOrderInfo.total }}</dd>
          </dl>
          <dl>
            <dt>订单支付金额</dt>
            <dd>￥{{ numFormat(relevantOrderInfo.total_pay_money) }}</dd>
          </dl>
          <dl>
            <dt>药品金额</dt>
            <dd>￥{{ numFormat(relevantOrderInfo.total_drug_price) }}</dd>
          </dl>
        </div>
        <div class="relevant-orders-body">
          <el-table :data="relevantOrdersTable"
                    tooltip-effect="dark"
                    style="width: 100%; "
                    :header-cell-style="{ background: '#F5F5F5' }"
                    @cell-dblclick="bindStaff">

            <el-table-column v-for="item in orderTableHeader"
                             :key="item.prop"
                             :prop="item.prop"
                             :label="item.label"
                             :width="item.width"
                             :fixed="item.fixed"
                             align="center">
              <template slot-scope="scope">
                <div v-if="item.prop == 'bind_staff'">
                  <div v-if="scope.row.isStaffShow"
                       style="display:flex">
                    <el-select v-model="value"
                               filterable
                               remote
                               reserve-keyword
                               placeholder="请输入"
                               :remote-method="remoteMethod"
                               :loading="loading"
                               size="mini">
                      <el-option v-for="item in staffOptions"
                                 :key="item.value"
                                 :label="item.label"
                                 :value="item.value">
                      </el-option>
                    </el-select>
                    <el-button style="margin-left:6px"
                               type="primary"
                               size="mini"
                               @click="confirmMoney(scope.row,index)">提交</el-button>
                    <el-button size="mini"
                               @click="scope.row.isStaffShow = false">取消</el-button>
                  </div>
                  <span v-else>{{scope.row.pay_money}}</span>
                </div>
                <div v-else>{{ scope.row[item.prop] }}</div>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import staff from '../../../../api/staff';
import Pagination from '@/components/Pagination/index.vue';
import dayjs from 'dayjs';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      staffOptions: [],
      value: [],
      list: [],
      loading: false,
      states: [
        'Alabama',
        'Alaska',
        'Arizona',
        'Arkansas',
        'California',
        'Colorado',
        'Connecticut',
        'Delaware',
        'Florida',
        'Georgia',
        'Hawaii',
        'Idaho',
        'Illinois',
        'Indiana',
        'Iowa',
        'Kansas',
        'Kentucky',
        'Louisiana',
        'Maine',
        'Maryland',
        'Massachusetts',
        'Michigan',
        'Minnesota',
        'Mississippi',
        'Missouri',
        'Montana',
        'Nebraska',
        'Nevada',
        'New Hampshire',
        'New Jersey',
        'New Mexico',
        'New York',
        'North Carolina',
        'North Dakota',
        'Ohio',
        'Oklahoma',
        'Oregon',
        'Pennsylvania',
        'Rhode Island',
        'South Carolina',
        'South Dakota',
        'Tennessee',
        'Texas',
        'Utah',
        'Vermont',
        'Virginia',
        'Washington',
        'West Virginia',
        'Wisconsin',
        'Wyoming'
      ],
      refreshKey: 0,
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      labelWidth: '100px',
      monthAndStaffForm: {
        phone: '',
        recommender_name: '',
        recommender_code: '',
        status: 0,
        order_sn: '',
        time_date: '',
        is_abnormal: 0
      },
      // isNotContain: true,
      options: [
        { label: '全部', value: 0, isShow: false },
        { label: '未扎帐', value: -11, isShow: true },
        { label: '未审批', value: 1, isShow: false },
        { label: '不可提', value: 2, isShow: false },
        { label: '已可提', value: 3, isShow: false },
        { label: '已提成', value: 4, isShow: false }
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: '本月',
            onClick(picker) {
              picker.$emit('pick', [new Date(), new Date()]);
            }
          },
          {
            text: '今年至今',
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近六个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      tableHeader: [
        { prop: 'date', label: '时间', width: 'auto' },
        { prop: 'recommender_name', label: '员工', width: 'auto' },
        { prop: 'recommender_money', label: '预算提成（元）', width: 'auto' },
        { prop: 'money', label: '可提成（元）', width: '300' },
        { prop: 'status', label: '状态', width: 'auto' }
      ],
      monthAndStaffTable: [],
      dialogOrder: false,
      relevantOrderInfo: {
        total: '',
        total_pay_money: '',
        total_drug_price: ''
      },
      orderTableHeader: [
        { prop: 'order_sn', label: '订单号', width: '200', fixed: false },
        {
          prop: 'drug_type_name',
          label: '类型剂型',
          width: 'auto',
          fixed: false
        },
        {
          prop: 'pay_money',
          label: '订单支付金额（元）',
          width: '160',
          fixed: false
        },
        { prop: 'drug_price', label: '药品金额', width: 'auto', fixed: false },
        {
          prop: 'recommender_money',
          label: '预算提成（元）',
          width: '130',
          fixed: false
        },
        {
          prop: 'recommender_proportion',
          label: '提成比例',
          width: 'auto',
          fixed: false
        },
        {
          prop: 'bind_staff',
          label: '业务员（双击改绑定）',
          width: '240',
          fixed: 'right'
        }
      ],
      relevantOrdersTable: [],
      batchSetArr: []
    };
  },
  filters: {
    dateFormat(date) {
      return date.slice(0, 4) + '-' + date.slice(4);
    },
    filterStatus(val) {
      switch (val) {
        case 1:
          return '不可提';
        case 2:
          return '已可提';
        case 3:
          return '未审批';
        case 4:
          return '已提成';
        default:
          return '未扎帐';
      }
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array || [];
    },
    isSetMention() {
      if (!this.batchSetArr.length) {
        return true;
      }
      return !this.batchSetArr.every((item) => {
        return item.status == 1;
      });
    },
    isSetNotMention() {
      if (!this.batchSetArr.length) {
        return true;
      }
      return !this.batchSetArr.every((item) => {
        return item.status == 2;
      });
    },
    isPass() {
      if (!this.batchSetArr.length) {
        return true;
      }
      return !this.batchSetArr.every((item) => {
        return item.status == 3;
      });
    },
    isSetAbnormal() {
      if (!this.batchSetArr.length) {
        return true;
      }
      return this.batchSetArr.some((item) => {
        return !item.status || item.status == 4;
      });
    }
  },
  created() {
    this.getList();
  },
  mounted() {
    this.list = this.states.map((item) => {
      return { value: `value:${item}`, label: `label:${item}` };
    });
  },
  methods: {
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.staffOptions = this.list.filter((item) => {
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.staffOptions = [];
      }
    },
    getList() {
      this.tableLoading = true;
      let params = Object.assign(this.pagination, this.monthAndStaffForm);
      if (params.time_date) {
        params['time_date_start'] = params.time_date[0];
        params['time_date_end'] = params.time_date[1];
      } else {
        params['time_date_start'] = '';
        params['time_date_end'] = '';
      }
      params['is_transaction'] = !this.options[1].isShow ? 0 : 1;
      staff.getProportionManageList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          let info = {
            total_transaction_money: data.total_transaction_money,
            total_no_get_money: data.total_no_get_money,
            total_get_money: data.total_get_money,
            total_ready_money: data.total_ready_money,
            total_money: data.total_money
          };
          this.$emit('getInfo', info);
          this.totalNum = data.total;
          this.monthAndStaffTable = data.list.map((item) => {
            item.isMoneyShow = false;
            return item;
          });
        }
        this.tableLoading = false;
      });
    },
    // 是否扎帐
    transactionClick() {
      this.getList();
    },
    // 设置可提成
    editorMoney(row, column, cell, event) {
      if (this.module_id_array.includes('642')) {
        return;
      }
      if (!row.status || row.status == 4) {
        return;
      }
      if (column.property === 'money') {
        row.isMoneyShow = true;
      }
    },
    // 确认可提成
    confirmMoney(row, index) {
      if (row.money > row.recommender_money) {
        this.$confirm('可提成修改后大于预算提成，是否修改?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        })
          .then(() => {
            this.setPercentageMoney(row);
          })
          .catch(() => {});
      } else {
        this.setPercentageMoney(row);
      }
    },
    // 设置提成接口
    setPercentageMoney(row) {
      let params = {
        income_id: row.income_id,
        money: row.money
      };
      staff.setPercentageMoney(params).then((res) => {
        let { code } = res;
        if (code == 0) {
          this.$message.success('设置成功');
          row.isMoneyShow = false;
          this.refreshKey = this.refreshKey++;
        }
      });
    },
    // 导出
    outData() {
      let params = Object.assign(this.monthAndStaffForm);
      if (params.time_date) {
        params['time_date_start'] = params.time_date[0];
        params['time_date_end'] = params.time_date[1];
      } else {
        params['time_date_start'] = '';
        params['time_date_end'] = '';
      }
      params['is_transaction'] = params.status == -11 ? 0 : 1;
      staff.exportProportionList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          window.open(data.url);
        }
      });
    },
    // 批量设置可提
    batchSetMention() {
      let incomeIdArr = this.batchSetArr.map((item) => {
        return item.income_id;
      });
      let params = {
        income_id: incomeIdArr.join(','),
        status: 2
      };
      this.setStaffApplyStatus(params);
    },
    // 批量设置不可提
    batchSetNotMention() {
      let incomeIdArr = this.batchSetArr.map((item) => {
        return item.income_id;
      });
      let params = {
        income_id: incomeIdArr.join(','),
        status: 1
      };
      this.setStaffApplyStatus(params);
    },
    // 可提、不可提接口
    setStaffApplyStatus(params) {
      staff.setStaffApplyStatus(params).then((res) => {
        let { code } = res;
        if (code == 0) {
          this.$message.success('设置状态成功');
          this.getList();
        }
      });
    },
    // 批量通过
    batchPass() {
      let incomeIdArr = this.batchSetArr.map((item) => {
        return item.income_id;
      });
      let params = {
        income_id: incomeIdArr.join(',')
      };
      this.passStaffApplyInfo(params);
    },
    // 审批接口
    passStaffApplyInfo() {
      staff.passStaffApplyInfo().then((res) => {
        let { code } = res;
        if (code == 0) {
          this.$message.success('审批通过');
        }
      });
    },
    // 设为异常
    setAbnormal() {
      let incomeIdArr = this.batchSetArr.map((item) => {
        return item.income_id;
      });
      let params = {
        income_id: incomeIdArr.join(','),
        is_abnormal: 1
      };
      this.setStaffApplyAbnormal(params);
    },
    // 取消异常
    cancelAbnormal() {
      let incomeIdArr = this.batchSetArr.map((item) => {
        return item.income_id;
      });
      let params = {
        income_id: incomeIdArr.join(','),
        is_abnormal: 0
      };
      this.setStaffApplyAbnormal(params);
    },
    // 设置异常接口
    setStaffApplyAbnormal(params) {
      staff.setStaffApplyAbnormal(params).then((res) => {
        let { code } = res;
        if (code == 0) {
          this.$message.success('设置异常状态成功');
          this.getList();
        }
      });
    },
    // -----
    handleSelectionChange(val) {
      this.batchSetArr = val;
    },
    // 相关订单
    relevantOrdersBtn(row) {
      let params = {
        recommender_code: row.recommender_code,
        date: row.date
      };
      staff.getRelatedOrderList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.relevantOrderInfo = {
            total: data.total,
            total_pay_money: data.total_pay_money,
            total_drug_price: data.total_drug_price
          };
          this.relevantOrdersTable = data.list.map((item) => {
            item.isStaffShow = false;
            return item;
          });
          this.dialogOrder = true;
        }
      });
    },
    // 绑定业务员
    bindStaff(row, column, cell, event) {
      console.log(1);
      if (column.property === 'bind_staff') {
        row.isStaffShow = true;
      }
    },
    // 设为可提
    setMention(row) {
      let params = {
        income_id: row.income_id,
        status: 2
      };
      this.setStaffApplyStatus(params);
    },
    // 设为不可提
    setNotMention(row) {
      let params = {
        income_id: row.income_id,
        status: 1
      };
      this.setStaffApplyStatus(params);
    },
    // 通过
    passBtn(row) {
      this.passStaffApplyInfo({
        income_id: row.income_id
      });
    },
    searchList() {
      this.pagination.page = 1;
      this.getList();
    },
    resetBtn() {
      for (let key in this.monthAndStaffForm) {
        if (key == 'status') {
          this.monthAndStaffForm[key] = 0;
        } else if (key == 'is_abnormal') {
          this.monthAndStaffForm[key] = 0;
        } else {
          this.monthAndStaffForm[key] = '';
        }
      }
      this.options[1].isShow = true;
      this.getList();
    },
    numFormat(num) {
      var c =
        num.toString().indexOf('.') !== -1
          ? num.toLocaleString()
          : num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      return c;
    }
  }
};
</script>

<style lang="scss" scoped>
.month-and-staff {
  .month-and-staff-header {
    .el-form {
      display: flex;
      flex-wrap: wrap;
    }
    .fun-point {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .batch {
        margin-left: 20px;
      }
      .abnormal {
        margin-left: 20px;
      }
    }
  }
  .month-and-staff-body {
    margin-top: 10px;
    .editor-money-box {
      display: flex;
      .el-input-number {
        margin-right: 4px;
      }
      // display: flex;
    }
    ::v-deep .el-badge__content.is-fixed {
      top: 10px;
      right: 0;
    }
  }
}
.relevant-orders {
  padding: 10px;
  .relevant-orders-header {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 20px;
    dl {
      margin: 0 20px;
      text-align: center;
      dd {
        margin: 0;
      }
    }
  }
}
</style>